import axios from 'axios'
import router from "../router/index"

import {
  Message
} from 'element-ui'



// 创建axios 实例
const service = axios.create({
  // baseURL: process.env.baseUrl, // api的base_url
  // baseURL: window.location.origin + '/api/', // url = baseurl + request url
  // baseURL: "https://yicai.newacademic.net/api/",//线上化地址
  baseURL: "https://eastrans.newacademic.net/api/", //线上化地址
  // baseURL:'http://192.168.100.181:80/api/',     //yiocai    
  // baseURL:'http://192.168.66.60:9000/api/',//王金平本地  



  timeout: 500000 // 请求超时时间  
})
if (window.localStorage.getItem("usid") == 'undefined') {
  window.localStorage.clear()
}

service.interceptors.request.use((config) => {
  if (router.currentRoute.name == 'demo') {
    config.headers.common = {
      USID: 'wBnPWPhLLfXHh3+yfCyajMGe2k1O+'
    }
  } else {
    if (window.localStorage.getItem("usid") && window.localStorage.getItem("usid") !== 'undefined') {

      // 动态设置请求头

      config.headers.common = {
        USID: JSON.parse(window.localStorage.getItem("usid"))
      }
    } else {
      window.localStorage.clear()
    }
  }

  if (config.url == 'translate/contrast/') {
    if (config.method === 'post') {
      config.data = {
        ...config.data,
        t: Date.parse(new Date())
      }
    } else if (config.method === 'get') {
      config.params = {
        ...config.params,
        t: Date.parse(new Date())
      }
    }
  } else {
    if (config.method === 'post') {
      // config.data = {
      //   ...config.data,
      //   t: Date.parse(new Date())
      //}
    } else if (config.method === 'get') {
      // config.params = {
      //   ...config.params,
      //   t: Date.parse(new Date())
      // }
    }
  }
  return config
}, (err) => {
  return Promise.reject(err)
})

service.interceptors.response.use((res) => {

  if (res.data.data == 401) {
    Message({
      message: '登录状态已失效,请重新登录',
      type: 'warning'
    });
    // window.localStorage.clear()
    // router.replace({
    //   name: 'login'
    // })
    return
  }
  if (res.data.data == 402) {
    Message({
      message: '你的账号已过期！',
      type: 'warning'
    });
    // window.localStorage.clear()
    // router.replace({
    //   name: 'login'
    // })
    return
  }

  return res
}, (err) => {
  //   Message({
  //     message: '发生异常,请重新登录',
  //     type: 'warning'
  //   });
  //   window.localStorage.clear()
  //   router.replace({
  //     name: 'login'
  //   })


  return Promise.reject(err)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js